<template>
    <div>
        <modal-x :show="showShopInfoCat" @onclose="showShopInfoCat = false"
            :content-style="{ maxWidth: '800px', height: 'calc(100% - 40px)' }">
            <div>Categories</div>
            <category v-if="showShopInfoCat" :user-id="shopInfo.shopUserId" :cat-node="shopInfoCatNode" :show-checkbox="false" :show-buttons="false" :view-mode="{}"
                @catSelected="onCatChange" cat-type="shopInfo" :expandAll="true"></category>
        </modal-x>
        <modal-x :show="showCatConfigs" @onclose="showCatConfigs=false" :content-style="{ maxWidth: '800px', height: 'calc(100% - 40px)' }">
            <category-configs :user-id="shopInfo.shopUserId"></category-configs>
        </modal-x>
        <div class="row">
            <div class="col-xs-12">
                <div class="btn btn-default" @click="selectShopInfoCat">
                    <span class="glyphicon glyphicon-minus" v-if="showShopInfoCat || showShopInfoCat2"></span>
                    <span class="glyphicon glyphicon-plus" v-else></span>
                    <span
                        v-if="newLabel.catPair !== null">{{ newLabel.catPair.parent.name }}/{{ newLabel.catPair.child.name }}</span>
                    <span v-else>{{ lang.common.infoType }}</span>
                </div>
                <div v-if="cpdIsManagers" class="btn btn-default" @click="showCatConfigs=true" style="float:right;">                    
                    <span>{{ lang.common.infoConfigs }}</span>
                </div>
            </div>
        </div>



        <div>
            <category v-if="showShopInfoCat2" :user-id="shopInfo.shopUserId" :cat-node="shopInfoCatNode" :show-checkbox="false" :show-buttons="false" :view-mode="{}"
            @catSelected="onCatChange" cat-type="shopInfo" :expandAll="true"></category>
        </div>


        <div>
            <div v-if="labelType !== null" class="col-xs-12"
                style="padding:4px;border:1px solid #ddd;background: rgba(1,1,1,0.2);">
                <label-entry-tpl :shop-info="shopInfo" :new-label="newLabel" :label-type="labelType">
                </label-entry-tpl>
                <div class="col-xs-12" style="text-align:right;">
                    <input type="button" class="btn btn-primary" @click="addCatLabel(newLabel)" value="Create" />
                </div>
            </div>
        </div>

    </div>
</template>
<script>
import imageList from './imageList.vue';
import modalX from '../components/base/ModalX1.vue';
import labelEntryTpl from './labelEntryTpl.vue';
import apis from '../api/extApi.js';
import category from './category.vue';
import categoryConfigs from './categoryConfigs.vue';

function _getlabelValTmpl() { return { frnImgPath: null, text0: null, text1: null, label: null, catId: null, catPair: null } };

export default {
    components: {
        category: category,
        categoryConfigs: categoryConfigs,
        labelEntryTpl: labelEntryTpl,
        imageList: imageList,
        modalX: modalX
    },
    props: ["shopInfo","showInfoCats"],
    computed:{
        lang: function () {
            return this.$store.getters.lang;
        },
        cpdIsManagers: function () {
            var dp = this.dashProfile;
            return dp !== null && (dp.isAdmin === true || dp.isManager === true);
        },
        dashProfile: function () {
            return this.$store.getters.dashProfile;
        }
    },
    data: function () {
        return {
            catCodes: apis.api.settings.catCodes,
            apiClient: apis.api,
            uiClient: apis.ui,
            newLabel: _getlabelValTmpl(),
            imgHandler: null,
            isSelectingImage: false,
            selectedImgs: [],
            labelType: null,
            shopInfoCatNode: null,
            showShopInfoCat: false,
            showShopInfoCat2:false,
            showCatConfigs:false
        };
    },
    methods: {
        onCatChange: function (catPair) {
            console.log('catPair', catPair);
            this.newLabel = _getlabelValTmpl();
            var catId = catPair.child.catId;
            this.newLabel.catId = catId;
            this.newLabel.catPair = catPair;
            this.apiClient.getShopInfoLabelByCatIdPrms(catId).done((ret) => {
                this.labelType = ret.label.label;
                this.showShopInfoCat = false;
                this.showShopInfoCat2=false;
            });
        },
        selectShopInfoCat: function () {
            console.log('selectShopInfoCat', this.shopInfo);
            this.showShopInfoCat = true;
            //this.showShopInfoCat2= false;
            this.loadShopInfoCat();
        },
        selectShopInfoCat2: function () {
            console.log('selectShopInfoCat2', this.shopInfo);
            this.showShopInfoCat2 = true;
            this.loadShopInfoCat();
        },
        loadShopInfoCat:function(){
            this.apiClient.getCategoryNodePrms(this.catCodes.shopInfo, this.shopInfo.shopUserId).done((ret) => {
                console.log('getCategoryNodePrms', ret);
                this.shopInfoCatNode = ret;
            });
        },
        onImgSelect: function (imgFile) {
            this.selectedImgs.push(imgFile);
            this.imgHandler(imgFile, this.selectedImgs);
        },
        setNewLabelImg: function (newImg) {
            this.newLabel.frnImgPath = newImg.thumbPath;
            this.newLabel.label = newImg.fileName + newImg.fileType;
            this.isSelectingImage = false;
        },
        selectImg: function (handler) {
            this.imgHandler = handler;
            this.isSelectingImage = !this.isSelectingImage;
        },
        addCatLabel: function (label) {
            this.$emit('onadd', label);
        }
    },
    created: function () {

    },
    mounted: function () {
        this.showShopInfoCat2 = this.showInfoCats;
        if(this.showShopInfoCat2){
            this.selectShopInfoCat2();
        }
    },
    watch: {
        'showInfoCats'(newVal,oldVal) {
            console.log('showInfoCats newVal:',newVal);
            if(newVal===true){
                this.selectShopInfoCat2();
            }else{
                this.showShopInfoCat2=false;
            }
        }
    }
}
</script>